import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { API, inr } from "../lib/api";
import { Link } from "react-router-dom";

export default function GuessPrice() {
  const [g, setG] = useState(null);
  const [picked, setPicked] = useState(null);
  const load = () => { setPicked(null); API.get("/games/guess-price").then((r) => setG(r.data)).catch(() => setG(null)); };
  useEffect(() => { load(); }, []);
  if (!g) return null;
  return (
    <div className="bg-gradient-to-br from-[#1C1917] to-[#3d1a24] text-white rounded-2xl p-6" data-testid="guess-price">
      <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#F6A5BE] flex items-center gap-1.5"><Sparkles className="w-4 h-4" /> Guess the Club Price</p>
      <div className="flex gap-4 mt-4 items-center">
        {g.image && <img src={g.image} alt={g.title} className="w-20 h-20 rounded-xl object-cover" />}
        <div><p className="font-medium">{g.title}</p><p className="text-sm text-stone-300">Regular price {inr(g.regular_price)}</p></div>
      </div>
      <p className="text-sm text-stone-300 mt-4">What do you think the Club price is?</p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mt-3">
        {g.options.map((o) => {
          const correct = picked != null && o === g.club_price;
          const wrong = picked === o && o !== g.club_price;
          return (
            <button key={o} onClick={() => picked == null && setPicked(o)} disabled={picked != null} data-testid={`guess-opt-${o}`}
              className={`py-2.5 rounded-xl font-semibold text-sm transition-colors ${correct ? "bg-green-500 text-white" : wrong ? "bg-stone-600 text-stone-300" : "bg-white/10 hover:bg-white/20"}`}>{inr(o)}</button>
          );
        })}
      </div>
      {picked != null && (
        <div className="mt-4 text-center">
          <p className="text-sm">{picked === g.club_price ? "Spot on! 🎉" : `Club price is ${inr(g.club_price)}`}</p>
          <Link to="/club" className="inline-block mt-2 text-xs font-bold bg-[#6A1B29] px-4 py-2 rounded-full" data-testid="guess-join">JOIN CLUB TO UNLOCK</Link>
          <button onClick={load} className="ml-2 text-xs text-stone-300 underline" data-testid="guess-again">Try another</button>
        </div>
      )}
    </div>
  );
}
